import z from 'zod';

export const clinicNameSchema = z.object({
  name: z.string().min(1, 'Clinic name is required'),
});

export type ClinicNameFormValues = z.infer<typeof clinicNameSchema>;
